<template>
  <div class="calico-tier">
    <div class="tier-indicator">
      <CalicoTierIndicator
        :active="tierConfig.colorBucket"
        :color-class="tierColorClass"
      />
    </div>
    <div class="display--small">
      {{ tierConfig.tier }}
    </div>
    <div class="body--small">
      {{ tierConfig.label }}
    </div>
  </div>
</template>

<script>
import CalicoTierIndicator from '@/components/calico/tierIndicator/index.vue'
import {
  BetaScoreTiers,
  BetaScoreTierMapping,
  BetaScoreLabels
} from '@/enums'

export default {
  name: 'CalicoTier',
  components: { CalicoTierIndicator },
  props: {
    tier: {
      type: String,
      default: BetaScoreTiers.UNAVAILABLE_TIER
    },
  },
  computed: {
    tierConfig() {
      const found = BetaScoreTierMapping.find(m => m.tier === this.tier)
      return (
        found || {
          tier: BetaScoreTiers.UNAVAILABLE_TIER,
          label: BetaScoreLabels.UNAVAILABLE_TIER_LABEL,
          colorBucket: 0
        }
      )
    },
    tierColorClass() {
      const bucket = this.tierConfig?.colorBucket
      switch (bucket) {
        case 5:
          return 'tier--prime'
        case 4:
          return 'tier--growth'
        case 3:
          return 'tier--emerging'
        case 2:
          return 'tier--monitor'
        case 1:
          return 'tier--caution'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss">
.calico-tier {
  @include stack-space($space-small);
  @include inset-space($space-small);
  width: fit-content;

  .tier-indicator {
    @include inline-space($space-none);
    align-items: center;
    justify-content: center;
  }

  .tier-label {
    line-height: 1;
  }
}
</style>
